import { useRef } from "react";
import * as THREE from "three";

export function useSceneRuntimeRefs() {
  const mountRef = useRef(null);
  const sceneObjectsRef = useRef({});
  const jointObjectsRef = useRef({});
  const slideJointLimitControlsRef = useRef({});
  const labelRendererRef = useRef(null);
  const siteLabelsRef = useRef({});
  const jointLabelRefs = useRef({});
  const rendererRef = useRef(null);
  const sceneRef = useRef(null);
  const cameraRef = useRef(null);
  const controlsRef = useRef(null);
  const isOrbitingRef = useRef(false);
  const preferPointerAfterOrbitRef = useRef(false);
  const previousBodiesRef = useRef(null);
  const modelGroupRef = useRef(null);
  const bodyTreeStructureSignatureRef = useRef("");
  const autoFitCameraRef = useRef(false);
  const sceneBuildTokenRef = useRef(0);
  const removedBodyCacheRef = useRef({});
  const isHistoryRestoringRef = useRef(false);
  const fileMapSignatureRef = useRef("");
  const previousFileMapKeysRef = useRef([]);
  const constraintVisualizationRef = useRef(null);
  const tendonVisualizationRef = useRef(null);
  const constraintMarkersGroupRef = useRef(null);
  const constraintMarkerMeshesRef = useRef([]);
  const pendingMeshLoadBodyCountsRef = useRef(new Map());
  const constraintPointerRef = useRef(new THREE.Vector2());
  const constraintHoveredKeyRef = useRef(null);
  const missingConstraintBodyToastKeysRef = useRef(new Set());
  const constraintMarkerBuildRetryCountRef = useRef(0);
  const positionGizmoControllerRef = useRef(null);
  const rotationGizmoControllerRef = useRef(null);
  const scaleGizmoControllerRef = useRef(null);
  const externalForceVizRef = useRef({
    byBodyUuid: new Map(),
  });
  const selectedGraspByBodyRef = useRef({});
  const ikMarkerFocusGraspRef = useRef(false);
  const physicsPoseLogDoneRef = useRef(false);
  const padPoseLogDoneRef = useRef(false);
  const physicsPoseApplyLoggedRef = useRef(new Set());
  const zeroBodySyncWarningSignatureRef = useRef("");
  const rolloutProbeRef = useRef({
    lastWarnMs: 0,
    lastSignature: null,
    sceneApplyProbeDone: false,
    sceneApplyProbeKey: null,
  });

  return {
    autoFitCameraRef,
    bodyTreeStructureSignatureRef,
    cameraRef,
    constraintHoveredKeyRef,
    constraintMarkerBuildRetryCountRef,
    constraintMarkerMeshesRef,
    constraintMarkersGroupRef,
    constraintPointerRef,
    constraintVisualizationRef,
    controlsRef,
    externalForceVizRef,
    fileMapSignatureRef,
    ikMarkerFocusGraspRef,
    isHistoryRestoringRef,
    isOrbitingRef,
    jointLabelRefs,
    jointObjectsRef,
    labelRendererRef,
    missingConstraintBodyToastKeysRef,
    modelGroupRef,
    mountRef,
    padPoseLogDoneRef,
    pendingMeshLoadBodyCountsRef,
    physicsPoseApplyLoggedRef,
    physicsPoseLogDoneRef,
    positionGizmoControllerRef,
    preferPointerAfterOrbitRef,
    previousBodiesRef,
    previousFileMapKeysRef,
    removedBodyCacheRef,
    rendererRef,
    rolloutProbeRef,
    rotationGizmoControllerRef,
    scaleGizmoControllerRef,
    sceneBuildTokenRef,
    sceneObjectsRef,
    sceneRef,
    selectedGraspByBodyRef,
    siteLabelsRef,
    slideJointLimitControlsRef,
    tendonVisualizationRef,
    zeroBodySyncWarningSignatureRef,
  };
}
